import React from 'react';
import { twMerge } from 'tailwind-merge';
import error_star from '../../resources/images/error_star.png';
import BaseButton from '../form/BaseButton.jsx';
import { useNavigate } from 'react-router-dom';
import { setError, setErrorReset } from '../../store/error.js';
import { useDispatch } from 'react-redux';

const BaseError = (props) => {
    const { className, status, statusText } = props;
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const redirectHome = () => {
        navigate('/');
        dispatch(setErrorReset({ reset: false, boundary: false }));
        dispatch(setError({ status: false, errorMessages: {} }));
    };

    return (
        <div className={twMerge('flex justify-center items-center mx-auto w-full max-w-3xl min-h-96', className)}>
            <div className={'p-5 py-8 mx-4 base-error-card text-center border border-theme1-error2 rounded-4xl'}>
                <h1 className='text-theme1-primary text-4xl font-bold'>Error {status}</h1>
                <img className={'mx-auto'} width={113} src={error_star} alt='Star'></img>
                {statusText && import.meta.env.VITE_APP_ENV === 'local' && (
                    <div className='mb-4 text-theme1-text1'>{statusText}</div>
                )}
                <h6 className={'text-theme1-text1 font-bold'}>Contact the developers if this might be a problem.</h6>
                <BaseButton
                    id='btn-submit'
                    className='btn-primary text-lg font-bold rounded-4xl w-40 mt-8'
                    onClick={() => redirectHome()}
                    textValue={'Go to Home'}
                />
            </div>
        </div>
    );
};

export default BaseError;
